// src/components/Navbar.js

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import Button from './Button';

function Navbar() {
  const navigate = useNavigate();
  const token = localStorage.getItem('accessToken');
  let user = null;

  if (token) {
    try {
      user = jwtDecode(token);
    } catch (error) {
      console.error("Error al decodificar el token:", error);
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
    }
  }

  const handleLogout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    navigate('/login');
  };

  const homePath = user ? (user.rol === 'PADRE' ? '/dashboard-padre' : '/dashboard-nino') : '/login';
  
  // --- LÓGICA PARA MOSTRAR EL NOMBRE ---
  // Si el usuario tiene un 'first_name', lo usamos. Si no, usamos el 'username'.
  const displayName = user ? (user.first_name || user.username) : '';

  return (
    <nav className="bg-white shadow-md w-full px-8 py-4">
      <div className="container mx-auto flex justify-between items-center">
        <Link to={homePath} className="text-2xl font-bold text-principal">
          ✨ Tareas Mágicas
        </Link>

        {user && (
          <div className="flex items-center gap-4">
            {user.rol === 'NINO' ? (
                <Link to="/perfil" className="flex items-center gap-3 text-gray-700 font-semibold hover:bg-fondo p-2 rounded-lg transition-colors">
                    <span className="text-2xl">{user.avatar || '👤'}</span>
                    <span className="text-principal">{displayName}</span>
                </Link>
            ) : (
                <span className="text-gray-700 font-semibold">
                    Hola, <span className="text-principal">{displayName}</span>
                </span>
            )}
            
            <Button variant="danger" onClick={handleLogout}>
              Cerrar Sesión
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;